import React from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from "@mui/material";
import { useSelector } from "react-redux";

export default function UltimateFan({ config, onChange }) {
  const tenants = useSelector((state) => state.tenant?.tenants || []);

  const selectedTenantIds = Array.isArray(config?.selectedTenantIds)
    ? config.selectedTenantIds
    : Array.isArray(config?.tenantIds)
    ? config.tenantIds
    : [];

  const toggleTenant = (tenantId, checked) => {
    const nextIds = checked
      ? [...selectedTenantIds, tenantId]
      : selectedTenantIds.filter((id) => id !== tenantId);

    onChange({
      ...config,
      selectedTenantIds: nextIds,
    });
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle2" fontWeight={500}>
        Display Tenants
      </Typography>

      <FormGroup row>
        {tenants.map((tenant) => (
          <FormControlLabel
            key={tenant.tenantId}
            control={
              <Checkbox
                checked={selectedTenantIds.includes(tenant.tenantId)}
                onChange={(e) => toggleTenant(tenant.tenantId, e.target.checked)}
              />
            }
            label={tenant.name}
          />
        ))}
      </FormGroup>
    </Box>
  );
}
